import { render, staticRenderFns } from "./checkedDes.vue?vue&type=template&id=21d47b6c&scoped=true"
import script from "./checkedDes.vue?vue&type=script&lang=js"
export * from "./checkedDes.vue?vue&type=script&lang=js"
import style0 from "./checkedDes.vue?vue&type=style&index=0&id=21d47b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d47b6c",
  null
  
)

export default component.exports